import Cookies from 'js-cookie';

export default class AuthService {
  buildLoginRequest(data) {
    return {
      service: 'auth',
      endpoint: '/login',
      method: 'post',
      data,
    };
  }
  buildTwoFactorRequest(data) {
    return {
      service: 'auth',
      endpoint: '/login2fa',
      method: 'post',
      data,
    };
  }
  buildValidateRequest(cancelToken) {
    return {
      service: 'auth',
      endpoint: '/validate',
      method: 'get',
      cancelToken,
    };
  }
  buildLogoutRequest() {
    return { endpoint: '/logout', method: 'post', service: 'auth' };
  }

  setToken(token) {
    Cookies.set('token', token, { expires: 1 });
  }
  getToken() {
    return Cookies.get('token');
  }
  setUserRootOrgID(rootOrgID) {
    Cookies.set('rootOrgID', rootOrgID, { expires: 1 });
  }
  getUserRootOrgID() {
    return Cookies.get('rootOrgID');
  }
  setCurrentOrgID(orgID) {
    Cookies.set('currentOrgID', orgID, { expires: 1 });
  }
  getCurrentOrgID() {
    return Cookies.get('currentOrgID');
  }
  logout() {
    Cookies.remove('token');
    Cookies.remove('rootOrgID');
    Cookies.remove('currentOrgID');
    window.localStorage.clear();
  }
}
